import axios from "axios";
import { API_BASE_URL } from "../../config";
import { authHeaders } from "../utils/session";

const jsonHeaders = () => ({
  ...authHeaders(),
});

/** Surface the API's own reason — never axios's "Request failed with status …". */
const apiError = (err, fallback) => {
  const data = err?.response?.data;
  const firstFieldError = data?.errors?.[Object.keys(data?.errors || {})[0]]?.[0];
  return new Error(firstFieldError || data?.message || data?.error || fallback);
};

/**
 * Move an existing demo to a new slot.
 *
 * The backend updates the SAME Teams meeting, so the join link is preserved, and
 * it emails both the lead and the rep — the UI must not send its own mails.
 *
 * @param {number|string} id lead id
 * @param {{demo_date: string, demo_time: string}} payload date as YYYY-MM-DD,
 *        time as a slot label ("2:00 PM")
 * @returns the updated lead row
 */
export const rescheduleDemo = async (id, payload) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/reschedule-demo/${id}`, payload, {
      headers: jsonHeaders(),
    });
    const data = res.data || {};
    // Some endpoints answer 200 with a failure in the body.
    if (data.status === false || data.status === 422) {
      throw new Error(data.message || "Could not reschedule this demo");
    }
    return data.data || data.lead || null;
  } catch (err) {
    if (err instanceof Error && !err.response) throw err;
    throw apiError(err, "Could not reschedule this demo");
  }
};
